import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { apiFetch } from "../Api/apiFetch";
import { authClearAction, authSetUserAction, type AuthUser } from "../Redux/AppAuthReducer";

export function useBootstrapAuth(userEndpointUrl: string): void {
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const user = await apiFetch<AuthUser | null>(userEndpointUrl, { allowAnonymous: true });
        if (cancelled) return;
        if (user) dispatch(authSetUserAction(user));
        else dispatch(authClearAction());
      } catch {
        if (!cancelled) dispatch(authClearAction());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userEndpointUrl, dispatch]);
}
